import io from 'socket.io-client'

export const socket = io.connect('https://api.mypoet360.com');

// Expose the singleton socket on window so ChatContext can emit "login"
// (mapping userId -> socketId on the backend) as soon as it connects.
window.socket = socket;

